import { useTranslation } from 'react-i18next'
import MedicalAlertList from 'src/components/medical-alert-list/medical-alert-list.component'
import PatientFormCard from './patient-forms/patient-form-card.component'
import { TPatientMedAlert } from 'src/types/med-alert'
import { EFormType, TPatientForm } from 'src/types/form'
import { SPECIFIC_FORM_TYPES } from './patient-forms.component'

const OtherPatientInformation = ({
  patientMedAlerts,
  patientForms,
}: {
  patientMedAlerts: TPatientMedAlert[]
  patientForms: TPatientForm[]
}) => {
  const { t } = useTranslation()

  const patientMedAlertWithoutPatientFollowupId =
    patientMedAlerts?.filter((medAlert) => !medAlert.PatientMedEventId && !medAlert.PatientFollowupId) || []

  const patientFormsWithoutPatientFollowupId = patientForms
    .filter((pf) => !SPECIFIC_FORM_TYPES.includes(pf?.Form?.type as EFormType))
    .filter((pf) => !pf.PatientMedEventId && !pf.PatientFollowupId)

  if (
    patientMedAlertWithoutPatientFollowupId.length === 0 &&
    patientFormsWithoutPatientFollowupId.length === 0
  ) {
    return null
  }

  return (
    <div className="c-rounded-xl c-border-grey-300 c-border-2 c-p-6">
      <h3 className="c-font-bold">
        {t('components.patient.patient-file.body.followup-details.other-patient-reviews')}
      </h3>
      {patientMedAlertWithoutPatientFollowupId.length > 0 && (
        <div className="c-mt-4">
          <MedicalAlertList
            medicalAlertList={patientMedAlertWithoutPatientFollowupId}
            medAlertSize="SMALL"
            isWorkflow
          />
        </div>
      )}
      {patientFormsWithoutPatientFollowupId.length > 0 && (
        <div className="c-mt-4 c-flex c-flex-col c-gap-4">
          {patientFormsWithoutPatientFollowupId?.map((patientForm) => (
            <PatientFormCard key={`patient-form-${patientForm.id}`} patientForm={patientForm} />
          ))}
        </div>
      )}
    </div>
  )
}

export default OtherPatientInformation
